import React from 'react';
import CommissionWidgets from './commission-widgets.jsx';
import NettWidgets from './nett-widgets.jsx';
import DiscountWidgets from './discount-widgets.jsx';
import { connect } from 'react-redux';

const Widgets = ({ rateType, dispatch, ratePackageIndex, ...extraProps }) => {
  const actionProps = {
    onChangeForApplyAll: payload => dispatch({ type: 'CHANGE_WIDGET_VALUE_FOR_APPLY_ALL', payload }),
    onChangeForProduct: payload => dispatch({ type: 'CHANGE_WIDGET_VALUE_FOR_PRODUCT', payload: Object.assign({}, payload, { ratePackageIndex }) }),
  };
  if (rateType === 'nett') return <NettWidgets {...extraProps } {...actionProps} />;
  if (rateType === 'commission') return <CommissionWidgets {...extraProps} {...actionProps} />;
  return <DiscountWidgets {...extraProps } {...actionProps} />;
};

const mapStateToProps = ({ contracting }) => ({
  rateType: contracting.massRateChange.get('rateType'),
});

export default connect(mapStateToProps)(Widgets);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/products/action-widgets/widgets.jsx